// @flow
import * as React from 'react';
import { art, asian, collectibles, fashion, furniture, home, jewelry, memorabilia } from './megaNavLinks';
import { getMegaNavImageUrlLarge, getMegaNavImageUrlSmall } from '../../../utils/urls';
import FindAuctions from './FindAuctions';
import isEqual from 'react-fast-compare';
import LinkContainer from './LinkContainer';
import MegaNavLink from './MegaNavLink';
import noop from '../../../utils/noop';
import styles from './Navigation.module.scss';

type Props = {|
    mobile: string,
    parent: any,
    trackPastAuctionResultsClick: Function,
|};

type State = {|
    active: number,
|};

export default class Navigation extends React.Component<Props, State> {
    static defaultProps = {
        parent: false,
    };

    state = { active: 0 };

    componentDidMount() {
        window.addEventListener('touchstart', this.handleClickOutside, false);
    }

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentWillUnmount() {
        window.removeEventListener('touchstart', this.handleClickOutside, false);
    }

    wrapper: ?HTMLDivElement;

    handleClickOutside = (event: SyntheticTouchEvent<>) => {
        if (this.props.mobile === 'tablet') {
            if (this.wrapper && this.wrapper.contains && !this.wrapper.contains((event.currentTarget: any))) {
                this.closeNav();
            }
        }
    };

    openNav = (key: number) => {
        return () => {
            this.setState({ active: key });
        };
    };

    closeNav = () => {
        if (this.state.active) {
            this.setState({ active: 0 });
        }
    };

    tabletNavigation = (link: string, key: number) => {
        return () => {
            if (this.state.active !== key) {
                this.setState({ active: key });
            } else {
                window.location.assign(link);
                this.setState({ active: 0 });
            }
        };
    };

    render() {
        const { mobile, parent, trackPastAuctionResultsClick } = this.props;

        const { active } = this.state;
        const isPhone = mobile && mobile !== 'tablet';
        return (
            <div className={styles.wrapper} ref={ref => (this.wrapper = ref)}>
                <div className={styles.navigation} onMouseLeave={!mobile ? this.closeNav : noop}>
                    <div className={styles['scroll-container']}>
                        <FindAuctions parent={parent} trackPastAuctionResultsClick={trackPastAuctionResultsClick} />
                        <div className={`${styles.item} ${styles.pipe}`}>|</div>
                        <div className={styles.navBar}>
                            <MegaNavLink
                                active={active === 1}
                                closeNav={this.closeNav}
                                link="/c/art/1/"
                                mobile={mobile}
                                msgId="navigation.art"
                                openNav={this.openNav(1)}
                                tabletNavigation={this.tabletNavigation('/c/art/1/', 1)}
                            />
                            <MegaNavLink
                                active={active === 2}
                                closeNav={this.closeNav}
                                link="/c/jewelry/6/"
                                mobile={mobile}
                                msgId="navigation.jewelry"
                                openNav={this.openNav(2)}
                                tabletNavigation={this.tabletNavigation('/c/jewelry/6/', 2)}
                            />
                            <MegaNavLink
                                active={active === 3}
                                closeNav={this.closeNav}
                                link="/c/asian/158/"
                                mobile={mobile}
                                msgId="navigation.asian_antiques"
                                openNav={this.openNav(3)}
                                tabletNavigation={this.tabletNavigation('/c/asian/158/', 3)}
                            />
                            <MegaNavLink
                                active={active === 4}
                                closeNav={this.closeNav}
                                link="/c/furniture/4/"
                                mobile={mobile}
                                msgId="navigation.furniture"
                                openNav={this.openNav(4)}
                                tabletNavigation={this.tabletNavigation('/c/furniture/4/', 4)}
                            />
                            <MegaNavLink
                                active={active === 5}
                                closeNav={this.closeNav}
                                link="/c/collectibles/2/"
                                mobile={mobile}
                                msgId="navigation.collectibles"
                                openNav={this.openNav(5)}
                                tabletNavigation={this.tabletNavigation('/c/collectibles/2/', 5)}
                            />
                            <MegaNavLink
                                active={active === -1}
                                closeNav={this.closeNav}
                                link="/c/coins-currency-stamps/24/"
                                mobile={mobile}
                                msgId="navigation.coins"
                                openNav={this.openNav(0)}
                                tabletNavigation={this.tabletNavigation('/c/coins-currency-stamps/24/', 0)}
                            />
                            <MegaNavLink
                                active={active === 6}
                                closeNav={this.closeNav}
                                link="/c/memorabilia/26429/"
                                mobile={mobile}
                                msgId="navigation.memorabilia"
                                openNav={this.openNav(6)}
                                tabletNavigation={this.tabletNavigation('/c/memorabilia/26429/', 6)}
                            />
                            <MegaNavLink
                                active={active === 7}
                                closeNav={this.closeNav}
                                link="/c/home-garden/5/"
                                mobile={mobile}
                                msgId="navigation.home_and_garden"
                                openNav={this.openNav(7)}
                                tabletNavigation={this.tabletNavigation('/c/home-garden/5/', 7)}
                            />
                            <MegaNavLink
                                active={active === 8}
                                closeNav={this.closeNav}
                                link="/c/fashion/3/"
                                mobile={mobile}
                                msgId="navigation.fashion"
                                openNav={this.openNav(8)}
                                tabletNavigation={this.tabletNavigation('/c/fashion/3/', 8)}
                            />
                        </div>
                    </div>
                    {!isPhone && (
                        <div>
                            <LinkContainer
                                active={active === 1}
                                closeNav={this.closeNav}
                                linkArray={art}
                                mobile={mobile}
                                picLinkL={getMegaNavImageUrlLarge('art')}
                                picLinkS={getMegaNavImageUrlSmall('art')}
                            />
                            <LinkContainer
                                active={active === 2}
                                closeNav={this.closeNav}
                                linkArray={jewelry}
                                mobile={mobile}
                                picLinkL={getMegaNavImageUrlLarge('jewelry')}
                                picLinkS={getMegaNavImageUrlSmall('jewelry')}
                            />
                            <LinkContainer
                                active={active === 3}
                                closeNav={this.closeNav}
                                linkArray={asian}
                                mobile={mobile}
                                picLinkL={getMegaNavImageUrlLarge('asian')}
                                picLinkS={getMegaNavImageUrlSmall('asian')}
                            />
                            <LinkContainer
                                active={active === 4}
                                closeNav={this.closeNav}
                                linkArray={furniture}
                                mobile={mobile}
                            />
                            <LinkContainer
                                active={active === 5}
                                closeNav={this.closeNav}
                                linkArray={collectibles}
                                mobile={mobile}
                                picLinkL={getMegaNavImageUrlLarge('collectibles')}
                                picLinkS={getMegaNavImageUrlSmall('collectibles')}
                            />
                            <LinkContainer
                                active={active === 6}
                                closeNav={this.closeNav}
                                linkArray={memorabilia}
                                mobile={mobile}
                                picLinkL={getMegaNavImageUrlLarge('memorabilia')}
                                picLinkS={getMegaNavImageUrlSmall('memorabilia')}
                            />
                            <LinkContainer
                                active={active === 7}
                                closeNav={this.closeNav}
                                linkArray={home}
                                mobile={mobile}
                            />
                            <LinkContainer
                                active={active === 8}
                                closeNav={this.closeNav}
                                linkArray={fashion}
                                mobile={mobile}
                                picLinkL={getMegaNavImageUrlLarge('fashion')}
                                picLinkS={getMegaNavImageUrlSmall('fashion')}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
